import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import MediaImage from "@/components/MediaImage";
import { milestoneLabel } from "@/milestones";
import { relativeTime } from "@/motion";
import { mono, num } from "@/components/home/Primitives";

// Bandeau compact (≤ 180 px) : une seule ligne d'information, pas une carte décorative.
export default function Hero({ hero, t, lang }) {
  if (!hero) return null;
  const prog = hero.kind === "top_progression";
  return (
    <Link to={`/players/${hero.player_id}?p=${hero.provider}`} data-testid="home-hero" data-kind={hero.kind}
      className="flex max-h-[180px] min-w-0 items-center gap-4 border-b border-[var(--wl-line)] py-3 transition-colors hover:bg-[var(--wl-panel)]">
      <MediaImage src={hero.photo_url || hero.club_logo} alt={hero.photo_url ? t("media.portrait_alt", { name: hero.name }) : t("media.logo_alt", { club: hero.club_name || "—" })}
        kind={hero.photo_url ? "player" : "club"} size={72} radius="rounded" surface="player_page" imgClassName={hero.photo_url ? "" : "object-contain p-2"} testid="home-hero-media" />
      <div className="min-w-0 flex-1">
        <p className={mono} data-testid="home-hero-kicker">{prog ? t("home.hero_top_progression") : t("home.hero_kicker")}</p>
        <p className="truncate font-sg text-xl font-bold uppercase tracking-[-0.03em] text-[var(--wl-text)] sm:text-2xl" data-testid="home-hero-name">
          {hero.name} <span className="text-[var(--wl-muted)]">· {hero.club_name}{hero.age ? ` · ${hero.age}` : ""}</span>
        </p>
        <p className="truncate text-sm text-[var(--wl-muted)]" data-testid="home-hero-sentence">
          {prog ? t("home.hero_progression_sentence", { delta: hero.delta, days: hero.window_days }) : t("home.hero_sentence", { milestone: milestoneLabel(hero, t).toLowerCase(), when: relativeTime(hero.detected_at, lang) })}
        </p>
      </div>
      {prog && <span className={`${num} hidden text-2xl font-bold text-[var(--wl-text)] sm:block`} data-testid="home-hero-progress">{hero.hype}</span>}
      <ArrowRight className="h-4 w-4 shrink-0 text-[var(--wl-muted)]" />
    </Link>
  );
}
